var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 32,
    rx: 16,
    fill: "#003675",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_766_3797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.463 8.43301C15.2776 6.86067 17.599 5.99666 20 6.00001C25.523 6.00001 30 10.477 30 16C30 18.136 29.33 20.116 28.19 21.74L25 16H28C28.0001 14.4316 27.5392 12.8978 26.6747 11.5893C25.8101 10.2807 24.5799 9.25517 23.1372 8.64013C21.6944 8.0251 20.1027 7.84771 18.56 8.13003C17.0172 8.41234 15.5915 9.14191 14.46 10.228L13.463 8.43301ZM26.537 23.567C24.7224 25.1393 22.401 26.0034 20 26C14.477 26 10 21.523 10 16C10 13.864 10.67 11.884 11.81 10.26L15 16H12C11.9999 17.5684 12.4608 19.1022 13.3253 20.4108C14.1899 21.7193 15.4201 22.7449 16.8628 23.3599C18.3056 23.9749 19.8973 24.1523 21.44 23.87C22.9828 23.5877 24.4085 22.8581 25.54 21.772L26.537 23.567Z",
    fill: "#FFCE00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_766_3797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReload);
export default __webpack_public_path__ + "static/media/icon_reload.7c9f0f65e1154754c2597e9be5243f21.svg";
export { ForwardRef as ReactComponent };